import { Contact } from "@/entities/contact";
import { formatPhone } from "@/shared/ui";
import { Badge, Button, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export interface ContactDetailsProps {
    selectedContact: Contact | null;
    selectedChatId: string | null;
    isAdmin: boolean;
    handleSetAdmin: (userId: string) => void;
}


const isAdminContact = (roles: string[]) => {
    return roles.includes("ADMIN")
}

export const ContactDetails = ({ selectedContact, selectedChatId, isAdmin, handleSetAdmin }: ContactDetailsProps) => {
    const navigate = useNavigate();

    if (!selectedContact) return (
        <div className="text-muted empty-state">Выберите контакт</div>
    );

    return (
        <div className="details-wrapper" >
            <div className="my-3 d-flex justify-content-md-start justify-content-center">
                {selectedContact.user.avatarUrl ? (
                    <Image
                        src={selectedContact.user.avatarUrl}
                        roundedCircle
                        width={100}
                        height={100}
                        style={{ objectFit: "cover" }}
                    />
                ) : (
                    <div
                        style={{
                            width: 100,
                            height: 100,
                            borderRadius: "50%",
                            backgroundColor: "#6c757d",
                            color: "white",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "bold",
                            fontSize: 40,
                        }}
                    >
                        {selectedContact.firstName?.[0]?.toUpperCase() || "?"}
                    </div>
                )}
            </div>

            <h3 className="details-name">
                Контакт: {selectedContact.firstName} {selectedContact.lastName}
            </h3>

            <div className="details-section">
                <h5>Данные контакта</h5>
                <p><span>Имя:</span> {selectedContact.firstName}</p>
                <p><span>Фамилия:</span> {selectedContact.lastName || "—"}</p>
            </div>

            <div className="details-section mt-4">
                <h5>Данные пользователя</h5>

                <p><span>Имя:</span> {selectedContact.user.firstName || "—"}</p>
                <p><span>Фамилия:</span> {selectedContact.user.lastName || "—"}</p>
                <p><span>Телефон:</span> {formatPhone(selectedContact.user.phone)}</p>

                <p>
                    <span>Дата регистрации:</span>{" "}
                    {new Date(selectedContact.user.createdAt).toLocaleString()}
                </p>

                <p>
                    <span>Статус:</span>
                    <Badge className="ms-2"
                        bg={selectedContact.user.status === "REGISTERED" ? "success" : "warning"}>
                        {selectedContact.user.status === "REGISTERED" ? "Зарегистрирован" : "Приглашён"}
                    </Badge>
                </p>

                <p>
                    <span>Роль:</span>
                    {isAdminContact(selectedContact.user.roles || []) ? " Админ" : " Пользователь"}
                </p>
            </div>

            <div className="d-flex flex-column" style={{ maxWidth: 300 }} >
                {isAdmin && !isAdminContact(selectedContact.user.roles || []) &&  (
                    <Button
                        size="sm"
                        variant="outline-secondary"
                        className="mt-3"
                        onClick={() => handleSetAdmin(selectedContact.user._id)}
                    >
                        Назначить администратором
                    </Button>
                )}
                <Button
                    size="sm"
                    variant="outline-secondary"
                    className={!isAdmin ? "mt-3" : "mt-2"}
                    onClick={() => navigate(`/?chat=${selectedChatId}`)}
                >
                    Перейти в чат
                </Button>
            </div>
        </div>
    );
};
